import { useRef, useState } from "react";
import type { WrappedFieldProps } from "redux-form";

import type { TextFieldProps } from "@braintrust/braintrust-ui-components";
import { Box } from "@braintrust/braintrust-ui-components";
import { EditPenIcon } from "@braintrust/braintrust-ui-components/Icons";
import { TextField } from "@js/forms/fields";

import styles from "./style.module.scss";

export const EditableTitleField = ({
  input,
  placeholder,
  meta,
  ...props
}: WrappedFieldProps & TextFieldProps) => {
  const [editMode, setEditMode] = useState(false);
  const wrapperRef = useRef<HTMLDivElement>(null);

  const makeItEditable = () => setEditMode(true);
  const makeItUnEditable = () => setEditMode(false);

  return (
    <Box
      ref={wrapperRef}
      className={styles.titleContainer}
      onClick={makeItEditable}
      onFocus={makeItEditable}
      onBlur={makeItUnEditable}
      sx={{ display: "flex", alignItems: "baseline" }}
    >
      <TextField
        size="large"
        inputTextSize="large"
        data-testid="job-title"
        placeholder={placeholder}
        input={input}
        hideBorder={!editMode}
        meta={meta}
        floatingLabel={false}
        variant="standard"
        {...props}
        slotProps={{
          htmlInput: {
            readOnly: !editMode,
          },
        }}
      />
      {!editMode && (
        <EditPenIcon
          className={styles.icon}
          style={{ color: "var(--grey-2)" }}
        />
      )}
    </Box>
  );
};
